module.exports = __webpack_public_path__ + "static/media/logo-white.57cca111.png";